import { render, staticRenderFns } from "./Turntable3.vue?vue&type=template&id=b93ee978&scoped=true&"
import script from "./Turntable3.vue?vue&type=script&lang=js&"
export * from "./Turntable3.vue?vue&type=script&lang=js&"
import style0 from "./Turntable3.vue?vue&type=style&index=0&id=b93ee978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93ee978",
  null
  
)

export default component.exports